import React from 'react';
import NumberFormat from 'react-number-format';
import * as PropTypes from 'prop-types';

function NumberFormatCount(props) {
    const { inputRef, onChange, ...other } = props;

    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={values => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value,
                    },
                });
            }}
            thousandSeparator=" "
            allowNegative={false}
            decimalScale={0}
        />
    );
}

NumberFormatCount.propTypes = {
    inputRef: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
};

export default NumberFormatCount;